import React,{useState, useEffect,useReducer} from 'react';
import './css/Login.css';
import {getAuth, createUserWithEmailAndPassword,signOut,signInWithEmailAndPassword,updateProfile} from 'firebase/auth';
import { db } from './firebase';
import { addDoc,deleteDoc, doc, getDocs, collection, query, where,serverTimestamp, getDoc, setDoc } from 'firebase/firestore';
import {Link, useNavigate} from "react-router-dom" ;
import { useBadge } from '@mui/base';
import {AnimatePresence, motion} from "framer-motion";
//redux stuff
import { useSelector, useDispatch} from 'react-redux';
import {setLoginStatus, setPhoto, setUserName,setReduxUserID } from "./redux/isLoggedIn";

import NoUserFoundPopup from './NoUserFoundPopup';

const Signup = React.memo(props => {
    const auth = getAuth();
    const [userName, setUserName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [userID, setUserID] = useState(''); 
    const [profileImage, setProfileImage] = useState(''); 
    const [loggedIn, setLoginStatus] = useState(window.localStorage.getItem('loggedIn')); 
    let navigate = useNavigate();
    let dispatch = useDispatch();

    const reduxIsLoggedIn = useSelector((state) => state.isLoggedIn.reduxIsLoggedIn);

    const [emailPlaceHolder, setEmailPlaceHolder] = useState('email');
    const [buttonLoading, setButtonLoading] = useState(false);
    const [noUserPopup, setNoUserPopup] = useState(false);

     //using useReducer() bc we have to update multiple properties at once
     function missingReducer(signupMissing,action){
        switch(action.type){
             case 'userName':{ return{ ...signupMissing, userName: action.payload.userName} }
             case 'email':{ return{ ...signupMissing, email: action.payload.email} }
             case 'password':{ return{ ...signupMissing, password: action.payload.password} }   
        }
   }
   //when using reducers, this is how to set up the 'state'
   const [signupMissing, dispatchMissing] = useReducer(missingReducer, {userName:false, email:false, password:false});   









    const signUp = () => {

        //check for missing values
        if(userName == ''){ dispatchMissing({type:'userName', payload:{userName:true}}) }
        if(email == ''){ 
            dispatchMissing({type:'email', payload:{email:true}}) 
            setEmailPlaceHolder("Enter an Email"); 
        }
        if(password == ''){ dispatchMissing({type:'password', payload:{password:true}}) }

        if(userName == '' && email == '' && password == ''  ){
            return;
        }

        //if the email is missing a '@', let the person know
        if( email.indexOf('@') == -1 && email != ''){ 
            setEmail('');
            setEmailPlaceHolder("You entered an invalid email address");
        }

        setButtonLoading(true);

        //from firebase
        createUserWithEmailAndPassword(auth,email,password)
        .then( (cred)=> {
          setDoc(doc(db, "users", cred.user.uid), {
            name: userName,
            email: email,
            password:password,
            headshot:"http://nick-georgiou.com/languageAppIcons/genericHeadShot.jpg"

          })
          console.log(cred.user);

          //localStorage
          window.localStorage.setItem('loggedIn', true);
          window.localStorage.setItem('username', userName);
          window.localStorage.setItem('userPhoto', "http://nick-georgiou.com/languageAppIcons/genericHeadShot.jpg");
          window.localStorage.setItem('userID', cred.user.uid);
          setLoginStatus(true);
          
          updateProfile(auth.currentUser, {
            displayName: userName,
          })

          navigate("/app/home");

        })
        .catch( (err) =>{
            setButtonLoading(false);
            console.log(err.message);

            if( (email.indexOf('@') == -1 || email.indexOf('.') == -1 ) && email != ''  ){ 
                dispatchMissing({type:'email', payload:{email:true}}) 
                setEmailPlaceHolder("You entered an invalid email address");
                setEmail('');
                return;
            }  

            /////if there's something wrong with the email
            else if( err.message.indexOf('auth/invalid-email') != -1 && email != ''  ){ 
                dispatchMissing({type:'email', payload:{email:true}}) 
                setEmail('');
                setEmailPlaceHolder("You entered an invalid email address");
                return;
            }    

            /////if there's no user that matches the entered data
            else if( err.message.indexOf('auth/email-already-in-use') != -1 ){ 
                setNoUserPopup(true);
            }            
            

        })//end catch()
 
    }


    const emailFocus = () => {
        dispatchMissing({type:'email', payload:{email:false}}); 
        setEmailPlaceHolder('email')
    }




    return (
        <motion.div initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}} transition={{duration:0.2}}>
            <div className='LoginContainer'>
                
                {noUserPopup &&
                    <NoUserFoundPopup email={email} setNoUserPopup={setNoUserPopup} message={'userExists'} />
                }              
                
                
                <div className='imageArea'></div>
                <div className='formContainer'>
                    
                    <h1 className='loginTitle signUp'>Sign Up</h1>
                    <p className='subTitle'>Free little test App, so a fake email is just fine &#128526;</p>

                
                    <div className='loginLabel'>Username</div>
                    <input 
                        type='text' 
                        value={userName} 
                        placeholder={ signupMissing.userName ? 'Enter a username' : 'username '}
                        className={ signupMissing.userName ? 'userName loginMissing' : 'userName '}
                        onChange = {(event) => setUserName(event.target.value)} 
                        onFocus = { () => dispatchMissing({type:'userName', payload:{userName:false}}) }
                    // onKeyPress={enterPressHack}
                    /> 
                    

                    <div className='loginLabel'>Email</div>
                    <input 
                        type='text' 
                        value={email} 
                        placeholder={ emailPlaceHolder }
                        className={ signupMissing.email ? 'email loginMissing' : 'email'}
                        onChange = {(event) => setEmail(event.target.value)} 
                        onFocus = { emailFocus }
                    // onKeyPress={enterPressHack}
                    />

                    <div className='loginLabel'>Password</div>
                    <input 
                        type='password' 
                        value={password} 
                        placeholder={ signupMissing.password ? 'Enter a password' : 'password '}
                        className={ signupMissing.password ? 'password loginMissing' : 'password '}
                        onChange = {(event) => setPassword(event.target.value)} 
                        onFocus = { () => dispatchMissing({type:'password', payload:{password:false}}) }
                    />

                    <div className='buttonArea'>
                        {buttonLoading &&
                            <div className='singupButtonLoadingArea'>
                                <div className='singupButtonLoading'></div>
                            </div>
                        }

                        <button className='loginButton' onClick={ signUp } >Sign Up</button>
                        
                    </div>
                    <div className='buttonArea'>
                        <p>Already have an account?  
                            <Link className='signUpLink' to="/app/">Sign In</Link>
                        </p>
                    </div>
                </div>{/* end formContainer */}

            {/* end formContainer */}
            </div> 
        </motion.div>
    )
})

export default Signup
